import { Flex, Loader, Text } from '@mantine/core';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props {
	challengeCode: string | null;
}

export const AwaitingSignStep = ({ challengeCode }: Props) => {
	const tCommonUi = useTranslationCommonUi();

	return (
		<Flex direction="column" gap="md" w="100%" align="center" pt="2rem" h="100%">
			{challengeCode && (
				<>
					<Text fw={600} size="lg">
						{tCommonUi('eid_easy_signing.verification_code')}
					</Text>
					<Text fw={700} size="xl" style={{ letterSpacing: '0.3em' }}>
						{challengeCode}
					</Text>
				</>
			)}
			<Loader size="md" />
			<Text size="sm" c="dimmed">
				{tCommonUi('eid_easy_signing.confirm_on_device')}
			</Text>
		</Flex>
	);
};
